import createIcon from './createIcon';
import * as icons from './assets';
export type { IconProps } from './createIcon.tsx';

export const AddIcon = createIcon(icons.Add);
export const ArrowDownIcon = createIcon(icons.ArrowDown);
export const ArrowLeftIcon = createIcon(icons.ArrowLeft);
export const ArrowRightIcon = createIcon(icons.ArrowRight);
export const ArrowUpIcon = createIcon(icons.ArrowUp);
export const BestPracticeIcon = createIcon(icons.BestPractice);
export const CalendarIcon = createIcon(icons.Calendar);
export const CartIcon = createIcon(icons.Cart);
export const CloseIcon = createIcon(icons.CloseIcon);
export const CompareIcon = createIcon(icons.Compare);
export const CheckMarkIcon = createIcon(icons.Correct);
export const DashboardIcon = createIcon(icons.Dashboard);
export const DeleteIcon = createIcon(icons.Delete);
export const FileIcon = createIcon(icons.File);
export const GridCardsIcon = createIcon(icons.GridCards);
export const ImageListIcon = createIcon(icons.ImageList);
export const HelpIcon = createIcon(icons.Help);
export const ImageIcon = createIcon(icons.Image);
export const ImprovementIcon = createIcon(icons.Improvement);
export const InformationIcon = createIcon(icons.Information);
export const LearningIcon = createIcon(icons.Learning);
export const LocaleIcon = createIcon(icons.Locale);
export const LongArrowLeftIcon = createIcon(icons.LongArrowLeft);
export const MoreIcon = createIcon(icons.More);
export const ProfileIcon = createIcon(icons.Profile);
export const ProjectsIcon = createIcon(icons.Projects);
export const SearchIcon = createIcon(icons.Search);
export const SettingsIcon = createIcon(icons.Settings);
export const StatusCompletedIcon = createIcon(icons.StatusCompleted);
export const StatusDeviationIcon = createIcon(icons.StatusDeviation);
export const StatusInactiveIcon = createIcon(icons.StatusInactive);
export const StatusOkIcon = createIcon(icons.StatusOk);
export const StatusPausedIcon = createIcon(icons.StatusPaused);
export const SuccessCircleIcon = createIcon(icons.SuccessCircle);
export const SurveysIcon = createIcon(icons.Surveys);
export const SymbolIcon = createIcon(icons.Symbol);
export const ShareIcon = createIcon(icons.Share);
export const ArrowDownRedIcon = createIcon(icons.ArrowDownRed);
export const ArrowUpGreenIcon = createIcon(icons.ArrowUpGreen);
export const StatusInactive2Icon = createIcon(icons.StatusInactive2);
export const StatusOk2Icon = createIcon(icons.StatusOk2);
export const StatusOk3Icon = createIcon(icons.StatusOk3);
export const Surveys2Icon = createIcon(icons.Surveys2);
export const ClockIcon = createIcon(icons.Clock);
export const PlusIcon = createIcon(icons.Plus);
export const Close2Icon = createIcon(icons.Close2Icon);
export const ErrorIcon = createIcon(icons.ErrorIcon);
export const BackIcon = createIcon(icons.BackIcon);
